import "./line-loader.scss";

export const LineLoader = () => {
	return (
		<div className='line-loader__wrapper'>
			<div className='line-loader__line line-loader'></div>
		</div>
	);
};
